export const iconFontAwesomeUsersPeoplePersonHalfDress = (
	<i className="fa-solid fa-person-half-dress"></i>
);
